//
// Copyright (c) 2018 Nutanix Inc. All rights reserved.
//
// HomePageLayout - Layout for the Home Page.
//

// Libs
import PropTypes from 'prop-types';
import React, { Component } from 'react';

// Components
import { MainPageLayout } from '@nutanix-ui/prism-reactjs';
import AppNavBar from 'components/AppNavBar';
import Toaster from 'components/Toaster';

import { getAuthService } from '../../api/auth-service';

// ----------------
// Home Page Layout
// ----------------

export class HomePageLayout extends Component {
    constructor() {
        super();

        this.state = {
            leftPanelVisible: false,
            toasterVisible: false,
        };

        // Bind event handlers
        this.toggleLeftPane = this.toggleLeftPane.bind(this);
        this.handleHideLeftPane = this.handleHideLeftPane.bind(this);
    }

    componentWillUnmount() {
        if (this.toasterRef) {
            clearTimeout(this.toasterRef);
        }
    }

    /**
     * Handle opening and closing the left panel.
     * @returns {void}
     */
    toggleLeftPane() {
        this.setState({
            leftPanelVisible: !this.state.leftPanelVisible,
        });
    }

    /**
     * Handle closing the left panel on page click.
     * @returns {void}
     */
    handleHideLeftPane() {
        this.setState({
            leftPanelVisible: false,
        });
    }

    onHandleClickLogout() {
        getAuthService().logout();
    }

    renderToaster() {
        const { toaster } = this.props;
        if (toaster) {
            return <Toaster text={toaster.text} type={toaster.type} />;
        }
        return null;
    }

    render() {
        const { children, oauth } = this.props;
        const username = oauth && oauth.decoded_jwt ? oauth.decoded_jwt.payload.email : '';
        const header = [
            <div key="toaster">{this.renderToaster()}</div>,
            <AppNavBar
                key="nav"
                borderless={true}
                handleClickMenu={this.toggleLeftPane}
                handleClickLogout={this.onHandleClickLogout}
                leftPanelVisible={this.state.leftPanelVisible}
                username={username}
            />,
        ];

        const body = [children];

        return (
            <MainPageLayout
                body={body}
                className="HomePageLayout"
                fullPage={true}
                header={header}
                leftPanel={null}
                leftPanelVisible={true}
            />
        );
    }
}

HomePageLayout.propTypes = {
    children: PropTypes.node.isRequired,
    // navigation: PropTypes.array,
    oauth: PropTypes.object,
    toaster: PropTypes.object,
};

HomePageLayout.defaultProps = {
    oauth: {},
};

export default HomePageLayout;
